import { createFileRoute } from '@tanstack/react-router';

interface EmployeeTemplateAddSearch {
  id?: string;
}

export const Route = createFileRoute('/w/employee-templates/add')({
  staticData: { hideShell: true },
  validateSearch: (search: Record<string, unknown>): EmployeeTemplateAddSearch => ({
    id: typeof search.id === 'string' ? search.id : undefined,
  }),
});
